import React, { useEffect, useState } from "react";
import auth_logo from "../../assets/auth_logo.png";
import join1 from "../../assets/join1.png";
import join2 from "../../assets/join2.png";
import join3 from "../../assets/join3.png";
import joi5 from "../../assets/join4.png";
import join5 from "../../assets/join5.png";
import { useNavigate } from "react-router";
import { IoSearch } from "react-icons/io5";
import { toastMessage } from "../../utils/toastMessage";
import { Link } from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import { joinGroupSignupApi } from "../../services/common";
import { avatar, logicalicon_blue } from "../../assets";
import { joinGroupApi } from "../../services/groups";
import { Button, LoadingButton } from "../../Components/header/form";

const Join_group = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const debouncedValue = useDebounce(search, 300);
  const [groupsData, setGroupData] = useState([])
  const [joinLoading, setJoinLoading] = useState(false)

  const [groupCountAccepted, setGroupCountAccepted] = useState(0);
  // console.log('groupCountAccepted', groupCountAccepted)
  useEffect(() => {
    exploreGroupListHandler();
  }, [debouncedValue]);

  useEffect(() => {
    // Calculate the count of groups with "ACCEPTED" status
    const countAccepted = groupsData.filter(group => group?.request?.status === 'ACCEPTED').length;
    setGroupCountAccepted(countAccepted);
  }, [groupsData]);
  const exploreGroupListHandler = async (page = 1, isRefresh = false) => {
    try {
      const { data } = await joinGroupSignupApi({
        pagination: "true",
        search: debouncedValue,
        limit: 20,
      });
      const { data: response, success, message, meta } = data;
      if (success) {
        setGroupData(response || [])
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };

  const joinGroupHandler = async (_id) => {
    try {
      setJoinLoading(true);
      const { data } = await joinGroupApi({ _id });
      const { success, message, data: response } = data;
      if (success) {
        exploreGroupListHandler()
      }
      toastMessage(message, success ? 'success' : "error", "joinHandler");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setJoinLoading(false);
    }
  };
  return (
    <>
      <div className="auth join_grp">
        <div className="custom_container">
          <div className="row">
            <div className="col-md-12">
              <div className="login_logo">
                <Link to="/">
                  <img src={logicalicon_blue} />
                </Link>
              </div>
            </div>
          </div>

          <div className="wrap_profile">
            <h2>Join Groups</h2>

            <p>
              Choose groups to connect with like-minded people and explore
              relevant content
            </p>

            <div className="search-container">
              <input onChange={(e) => setSearch(e.target.value)} type="text" placeholder="Search" />

              <div className="search-icon">
                <IoSearch />
              </div>
            </div>

            <div className="join-grp-5">
              <b>(Join at least 5 Groups)</b>
            </div>

            <div className="row">
              {/* <div className="group-list">
                {groupsData && groupsData.length > 0 ? groupsData.map((group) => (
                  { const countReqAccepted = group?.request?.status === 'ACCEPTED' }
                 setGroupCountAccepted = countReqAccepted
                  < div className = "group-item" key = { group._id } >
                  <div className="group-info">
                    <img
                      className="group-image"
                      src={group.coverImage || avatar}
                      alt={group.name || "N/A"}
                    />
                    <div className="group-details">
                      <div className="group-title">{group.name || "N'A"}</div>
                      <div className="group-category">{group.categoryName}</div>
                    </div>
                  </div>
                    <button
                      className={`group-action ${selectedGroups.includes(group._id) ? "joined" : ""
                        }`}
                      onClick={() => toggleGroupSelection(group.id)}
                    >
                      {selectedGroups.includes(group.id) ? "Joined" : "Join"}
                    </button>
                    { group?.request?.status === 'ACCEPTED' ?
                    <Button>{group?.request?.status}</Button> :

                    <LoadingButton
                      loading={joinLoading}
                      onClick={() => joinGroupHandler(group?._id)}
                    >
                      Join
                    </LoadingButton>}
              </div> */}
              <div className="group-list">
                {groupsData && groupsData.length > 0 ? (
                  groupsData.map((group) => (
                    <div className="group-item" key={group._id}>
                      <div className="group-info">
                        <img
                          className="group-image"
                          src={group.coverImage || avatar}
                          alt={group.name || "N/A"}
                        />
                        <div className="group-details">
                          <div className="group-title">{group.name || "N/A"}</div>
                          <div className="group-category">{group.categoryName}</div>
                        </div>
                      </div>
                      {group?.request?.status === "ACCEPTED" ? (
                        <button className="group-action joined">Joined</button>
                      ) : (
                        <LoadingButton
                          loading={joinLoading}
                          onClick={() => joinGroupHandler(group?._id)}
                        >
                          Join
                        </LoadingButton>
                      )}
                    </div>
                  ))
                ) : (
                  <h5 className="text-center mt-5">No Data Found</h5>
                )}
              </div>

              {/* <div className="button_wrap">
                <button
                  disabled={selectedGroups.length < 5}
                  onClick={() => {
                    navigate("/dashboard/overview");
                    localStorage.removeItem("authInfo");
                  }}
                  className={`button next-button continue  ${GroupCountAccepted.length < 5 ? "cstm_disabled_btn" : ""
                    }`}
                >
                  Continue
                </button>

              </div> */}
              <div className="button_wrap">
                <button
                  disabled={groupCountAccepted < 5}
                  onClick={() => {
                    navigate("/dashboard/overview");
                    localStorage.removeItem("authInfo");
                  }}
                  className={`button next-button continue ${groupCountAccepted < 5 ? "cstm_disabled_btn" : ""
                    }`}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default Join_group;
